import { createNativeStackNavigator } from '@react-navigation/native-stack'
import * as constants from 'constants'
import React from 'react'

import { EditProfilePage } from 'pages/EditProfile'
import { UserTypeSelectPage } from 'pages/UserTypeSelect'

export type OnboardingStackParamList = {
  [constants.links.ONBOARDING_USER_TYPE_PAGE]: undefined
  [constants.links.ONBOARDING_EDIT_PROFILE_PAGE]: undefined
}

const Stack = createNativeStackNavigator<OnboardingStackParamList>()

export const OnboardingStack = () => {
  const initialRouteName = constants.links.ONBOARDING_USER_TYPE_PAGE

  return (
    <Stack.Navigator initialRouteName={initialRouteName}>
      <Stack.Screen
        name={constants.links.ONBOARDING_USER_TYPE_PAGE}
        component={UserTypeSelectPage}
        options={{
          gestureEnabled: true,
          headerShown: false,
          title: 'Onboarding',
        }}
      />

      <Stack.Screen
        name={constants.links.ONBOARDING_EDIT_PROFILE_PAGE}
        options={{
          gestureEnabled: true,
          headerShown: false,
          title: 'Onboarding',
        }}
      >
        {(props) => <EditProfilePage onboardingView {...props} />}
      </Stack.Screen>
    </Stack.Navigator>
  )
}
